import { render, staticRenderFns } from "./DecomptesDCInval.vue?vue&type=template&id=670c9f30"
import script from "./DecomptesDCInval.vue?vue&type=script&lang=js"
export * from "./DecomptesDCInval.vue?vue&type=script&lang=js"
import style0 from "./DecomptesDCInval.vue?vue&type=style&index=0&id=670c9f30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports